import type { AtomSettingsMuteType } from "../../recoil/atoms/settings/types"
import type { DropdownItem } from "../common/dropdown/dropdown.interfaces"
import { RoomBranding } from "../../recoil/atoms/room/types"

export const DeviceTypes = {
  video: "video",
  audio: "audio"
} as const

export type TDeviceTypes = typeof DeviceTypes[keyof typeof DeviceTypes]

export const DevicePermissionState = {
  prompt: "prompt",
  granted: "granted",
  denied: "denied"
} as const

export const DevicePermissionType = {
  microphone: "microphone",
  camera: "camera"
} as const

export type TDevicePermissionStateKey = typeof DevicePermissionState[keyof typeof DevicePermissionState]
export type TDevicePermissionTypeKey = typeof DevicePermissionType[keyof typeof DevicePermissionType]


export type DeviceValuesState = {
  video: DropdownItem | null
  audio: DropdownItem | null
}

export type SettingsContainerProps = {
  onSubmit?: () => void
  isShowFullView?: boolean
  isHomePage?: boolean
  isMobile?: boolean
}

export type SettingsProps = {
  onSubmit: () => void
  devicesLists: DevicesLists
  handleChangeDevice: (type: TDeviceTypes, device: DropdownItem) => void
  handleChangeMuteDevice: (type: TDeviceTypes, isMuted: boolean) => void
  volume: number
  isShowFullView?: boolean
  currentVideo: DropdownItem
  currentAudio: DropdownItem
  currentMutedDevices: AtomSettingsMuteType
  tracks: any
  isHomePage: boolean
  isMobile?: boolean
  devicePermissionDenied?: {
    audio: boolean;
    video: boolean;
  }
}

export type SettingMicrophoneProps = {
  roomStyles: RoomBranding
  isShowFullView?: boolean
  handleChangeMuteDevice: (type: TDeviceTypes, isMuted: boolean) => void
  currentMutedDevices: AtomSettingsMuteType
  handleChangeDevice: (type: TDeviceTypes, device: DropdownItem) => void
  devicesLists: DevicesLists
  currentAudio: DropdownItem
  audioTrack: any
  isHomePage: boolean
  сolorBorder: string
  devicePermissionDenied?: {
    audio: boolean;
    video: boolean;
  }
}

export type SettingCameraProps = {
  roomStyles: RoomBranding
  isShowFullView?: boolean
  handleChangeMuteDevice: (type: TDeviceTypes, isMuted: boolean) => void
  currentMutedDevices: AtomSettingsMuteType
  handleChangeDevice: (type: TDeviceTypes, device: DropdownItem) => void
  devicesLists: DevicesLists
  currentVideo: DropdownItem
  videoTrack: any
  isHomePage: boolean
  сolorBorder: string
  devicePermissionDenied?: {
    audio: boolean;
    video: boolean;
  }
}

export type DevicesLists = {
  video: DropdownItem[]
  audio: DropdownItem[]
}
